import { createAction, handleActions } from 'redux-actions';
import createRequestSaga, {
  createRequestActionTypes,
} from '../../lib/createRequestSaga';
import { takeLatest } from 'redux-saga/effects';

import * as projectApi from '../../lib/api/project';
import { firstDayofYear, lastDayofYear } from '../../utils/calcDatetime';

const [
  LIST_MAIN_PROJECTS,
  LIST_MAIN_PROJECTS_SUCCESS,
  LIST_MAIN_PROJECTS_FAILURE,
] = createRequestActionTypes('project/LIST_MAIN_PROJECTS');

export const listMainProjects = createAction(
  LIST_MAIN_PROJECTS,
  (searchData) => searchData,
);
const listMainProjectsSaga = createRequestSaga(
  LIST_MAIN_PROJECTS,
  projectApi.getMainProjects,
);

const UNLOAD_MAIN_PROJECTS = 'project/UNLOAD_MAIN_PROJECTS';
export const unloadMainProjects = createAction(UNLOAD_MAIN_PROJECTS);

const SET_MAIN_PROJECT_FILTERS = 'project/SET_MAIN_PROJECT_FILTERS';
export const setMainProjectFilter = createAction(
  SET_MAIN_PROJECT_FILTERS,
  (filters) => filters,
);

const RESET_MAIN_PROJECT_FILTERS = 'project/RESET_MAIN_PROJECT_FILTERS';
export const resetMainProjectFilters = createAction(RESET_MAIN_PROJECT_FILTERS);

export function* mainProjectsSaga() {
  yield takeLatest(LIST_MAIN_PROJECTS, listMainProjectsSaga);
}

const initialState = {
  totals: null,
  projects: null,
  error: null,
  defaultFilters: {
    searchGrade: '',
    searchPrjImpt: ['High', 'Medium'],
    searchKeyword: 'cstNm',
    searchWords: '',
    searchStrtDt: firstDayofYear,
    searchEndDt: lastDayofYear,
  },
};

const mainProjects = handleActions(
  {
    [LIST_MAIN_PROJECTS_SUCCESS]: (state, { payload: data }) => ({
      ...state,
      totals: data.totals,
      projects: data.list.map((project) => ({
        id: project.prjUuid,
        prjUuid: project.prjUuid,
        prjSeq: project.prjSeq,
        prjNo: project.prjNo,
        prjTyp: project.prjTyp,
        prjImpt: project.prjImpt,
        expDay: project.expDay,
        bookingDay: project.bookingDay,
        cstStatus: project.cstStatus,
        cstGrade: project.cstGrade,
        cmpGrade: project.cmpGrade, //1/2/3/4
        cmpStatus: project.cmpStatus, //착수보고/분석설계/구축(이행)/완료(검수)
        cstNm: project.cstNm, //프로젝트명
        vendorCmpNm: project.vendorCmpNm, //매출처명
        clientCmpNm: project.clientCmpNm, //매출처명
        totalPurchase: project?.totalPurchase,
        totalSales: project?.totalSales,
        totalProfit: project?.totalProfit,
        useYn: project.useYn,
        ordYn: project.ordYn,
        crtDptNm: project.crtDptNm,
        crtNm: project.crtNm,
        crtGradeNm: project.crtGradeNm,
        crtDt: project.crtDt,
        cngNm: project.cngNm,
        cngDt: project.cngDt,
      })),
      error: null,
    }),
    [LIST_MAIN_PROJECTS_FAILURE]: (state, { payload: error }) => ({
      ...state,
      error: error,
    }),
    [UNLOAD_MAIN_PROJECTS]: () => initialState,
    [RESET_MAIN_PROJECT_FILTERS]: (state) => ({
      ...state,
      defaultFilters: initialState.defaultFilters,
    }),
    [SET_MAIN_PROJECT_FILTERS]: (state, { payload: filters }) => ({
      ...state,
      defaultFilters: filters,
    }),
  },
  initialState,
);

export default mainProjects;
